import React from "react";
import Index from "../components/BulkUploadCandidates.js";
import Sidebar from "../layouts/sidebar.js";
import Header from "../layouts/header.js";
import Layout from "../layouts/layout.js";
import PageHeading from "../layouts/pageHeading.js";
import { MdKeyboardArrowDown } from "react-icons/md";
import { cssProperties } from "../utils/commonCssProperties.js";
import { Typography } from "@mui/material";

const BulkUploadCandidate = () => {
  const breadcrumbs = [
    <Typography
      key="3"
      color="text.primary"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        color: cssProperties?.fontcolor?.primary,
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0.1px",
      }}
    >
      Candidate bulk upload <MdKeyboardArrowDown size={16} />
    </Typography>,
  ];
  return (
    <>
      <Sidebar />
      <Header breadcrumbs={breadcrumbs} />
      <Layout>
        <PageHeading title={"Scheduling Portal - Candidate Bulk Upload"} />
        <Index />
      </Layout>
    </>
  );
};

export default BulkUploadCandidate;
